// 워크스페이스 표준 퍼널 계측 — 정본은 `../../docs/munops/ops/release-integrity.md` §표준 계측 이벤트.
//
// 왜 자체 `/api/events`인가: 2026-08-11 실측에서 런체크의 유일한 계측은 edge가 자동 주입하는
// Cloudflare Web Analytics 비콘(`static.cloudflareinsights.com`)이었다. 표준 CSP의
// `script-src 'self'`는 그 비콘을 구조적으로 차단한다 — 보안 헤더를 붙이는 순간 계측이 조용히 죽는다.
// 그래서 헤더와 같은 변경에서 계측 소유권을 제품 안으로 가져온다.
//
// 실패는 삼킨다. 계측 실패가 제품 동작을 막으면 안 된다.

export type StandardEvent = "app_open" | "landing_view" | "activation_start" | "activation_done";

const fired = new Set<string>();

export function track(event: StandardEvent, props: Record<string, string | number | boolean> = {}, once = false) {
  if (once) {
    if (fired.has(event)) return;
    fired.add(event);
  }
  let synthetic = false;
  try { synthetic = typeof window !== "undefined" && window.localStorage.getItem("runcheck.synthetic") === "1"; } catch { /* Optional QA marking must not suppress the product event. */ }
  try {
    void fetch("/api/events", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ event, props: { ...props, ...(synthetic ? { synthetic: true } : {}) } }),
      keepalive: true,
      credentials: "omit",
    }).catch(() => undefined);
  } catch {
    /* 계측은 제품 동작을 막지 않는다 */
  }
}
